<template>
  <b-row>
    <b-col
      cols="12"
      md="12"
      lg="7"
      class="
        d-flex
        align-items-center
        justify-content-start
        mb-1 mb-lg-0
      "
    >
      <div
        class="d-flex align-items-center justify-content-start mr-1 mb-1 mb-md-0 w-100"
      >
        <label>Exibir</label>
        <v-select
          :value="perPage"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector d-inline-block mx-50"
          :searchable="false"
          @input="(val) => $emit('update:perPage', val)"
        />
        <label>entradas</label>
      </div>
      <v-select
        id="status-id"
        :value="statusFilter"
        class="w-100"
        name="status-id"
        :options="statusOptions"
        label="label"
        item-value="value"
        item-text="label"
        placeholder="Status"
        @input="(val) => $emit('update:statusFilter', val)"
      />
    </b-col>
    <!-- Search -->
    <b-col
      class="mt-1 mt-lg-0 d-flex align-items-center justify-content-start"
      cols="12"
      md="12"
      lg="5"
    >
      <div class="d-flex align-items-center justify-content-end w-100">
        <b-form-input
          :value="searchQuery"
          class="d-inline-block mr-1"
          placeholder="Buscar..."
          debounce="1000"
          @input="(val) => $emit('update:searchQuery', val)"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    vSelect,
  },
  props: {
    isAddNewPhysicianSidebarActive: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      required: true,
    },
    statusFilter: {
      type: [Object, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    perPageOptions: {
      type: Array,
      required: true,
    },
    searchQuery: {
      type: [String, null],
      default: null,
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
